import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FrameSwitcher, Frame } from '@beef/legacy-ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * FrameSwitcher with described propTypes and automatically disabled cycleMode and arrows
 */
export default class SmartFrameSwitcher extends React.Component {
  /**
   * To fix a bug where all the frames are aligned to the right side
   * we just fill in switcher with empty Frames to always have at least framesPerSlide elements
   */
  getEmptyFrames = () => {
    const { children, framesPerSlide } = this.props;
    const emptyFramesCount = framesPerSlide - React.Children.count(children);

    /**
     * create an array with `emptyFramesCount` elements,
     * and spawn a frame with no content for each of them
     */
    return Array.from({ length: emptyFramesCount }, (_, index) => (
      <Frame key={`Empty-${index}`}> </Frame>
    ));
  };

  render() {
    const { arrowClass, children, className, onStart, ...otherProps } = this.props;
    return (
      <div className={cx('container', className)}>
        <FrameSwitcher
          {...otherProps}
          className={cx('originalContainer')}
          arrowClass={['arrowExternal', arrowClass]}
          onSwitchStart={(e) => {
            onStart(e);
          }}
        >
          {children}
          {this.getEmptyFrames()}
        </FrameSwitcher>
      </div>
    );
  }
}

SmartFrameSwitcher.defaultProps = {
  framesPerSlide: 3,
  gutter: 20,
  noSwitch: true,
  onStart: () => {},
};

SmartFrameSwitcher.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  framesPerSlide: PropTypes.number,
  gutter: PropTypes.number,
  cycle: PropTypes.bool,
  noSwitch: PropTypes.bool,
  draggable: PropTypes.bool,
  arrowClass: PropTypes.string,
  onStart: PropTypes.func,
};
